module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "Under Development",
      "description": "Still in beta, not everything works (yet).",
      "show-icon": ""
    }
  }), _vm._v(" "), (_vm.site) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.utilLabel) + " Address")]), _vm._v(" "), (_vm.site.tenancy && _vm.site.tenancy.utilAddress) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.site.tenancy.utilAddress))])]) : _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v("No " + _vm._s(_vm.utilLabel) + " address found")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.actionData.currentStep,
      "space": 100,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Summary"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.actionData.steps[0].stepName
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.actionData.steps[1].stepName
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.actionData.steps[2].stepName
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.actionData.steps[3].stepName
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Site Address")]), _vm._v(" "), (_vm.site.address) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.site.address))])]) : _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v("No address found")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.site.subdistrict) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.site.subdistrict) + " ")]) : _vm._e(), _vm._v(" "), (_vm.site.district) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.site.district) + " ")]) : _vm._e(), _vm._v(" "), (_vm.site.region) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.site.region) + " ")]) : _vm._e(), _vm._v(" "), (_vm.site.state) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.site.state) + " ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card",
      "stretch": ""
    },
    on: {
      "tab-click": _vm.tabClicked
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "summary"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Summary")]), _vm._v(" "), _c('center', [_c('h2', [_vm._v("Summary")])]), _vm._v(" "), _c('kanban-board', {
    attrs: {
      "title": _vm.actionData.steps[0].stepName
    },
    model: {
      value: (_vm.actionData.steps[0].state),
      callback: function($$v) {
        _vm.$set(_vm.actionData.steps[0], "state", $$v)
      },
      expression: "actionData.steps[0].state"
    }
  }), _vm._v(" "), _c('kanban-board', {
    attrs: {
      "title": _vm.actionData.steps[1].stepName
    },
    model: {
      value: (_vm.actionData.steps[1].state),
      callback: function($$v) {
        _vm.$set(_vm.actionData.steps[1], "state", $$v)
      },
      expression: "actionData.steps[1].state"
    }
  }), _vm._v(" "), _c('kanban-board', {
    attrs: {
      "title": _vm.actionData.steps[2].stepName
    },
    model: {
      value: (_vm.actionData.steps[2].state),
      callback: function($$v) {
        _vm.$set(_vm.actionData.steps[2], "state", $$v)
      },
      expression: "actionData.steps[2].state"
    }
  }), _vm._v(" "), _c('kanban-board', {
    attrs: {
      "title": _vm.actionData.steps[3].stepName
    },
    model: {
      value: (_vm.actionData.steps[3].state),
      callback: function($$v) {
        _vm.$set(_vm.actionData.steps[3], "state", $$v)
      },
      expression: "actionData.steps[3].state"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "step1"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: _vm.actionData.steps[0].stepIcon
  }), _vm._v(" " + _vm._s(_vm.actionData.steps[0].stepName))]), _vm._v(" "), _c('center', [_c('h2', [_vm._v(_vm._s(_vm.actionData.steps[0].stepName))])]), _vm._v(" "), _c('progress-step1', {
    attrs: {
      "site-id": _vm.actionData.id,
      "row-data": _vm.actionData,
      "step-data": _vm.actionData.steps[0]
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "step2",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: _vm.actionData.steps[1].stepIcon
  }), _vm._v(" " + _vm._s(_vm.actionData.steps[1].stepName))]), _vm._v(" "), _c('center', [_c('h2', [_vm._v(_vm._s(_vm.actionData.steps[1].stepName))])]), _vm._v(" "), _c('progress-step2', {
    attrs: {
      "site-id": _vm.actionData.id,
      "row-data": _vm.actionData,
      "step-data": _vm.actionData.steps[1]
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "step3",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: _vm.actionData.steps[2].stepIcon
  }), _vm._v(" " + _vm._s(_vm.actionData.steps[2].stepName))]), _vm._v(" "), _c('center', [_c('h2', [_vm._v(_vm._s(_vm.actionData.steps[2].stepName))])]), _vm._v(" "), _c('progress-step3', {
    attrs: {
      "site-id": _vm.actionData.id,
      "row-data": _vm.actionData,
      "step-data": _vm.actionData.steps[2]
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "step4",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: _vm.actionData.steps[3].stepIcon
  }), _vm._v(" " + _vm._s(_vm.actionData.steps[3].stepName))]), _vm._v(" "), _c('center', [_c('h2', [_vm._v(_vm._s(_vm.actionData.steps[3].stepName))])]), _vm._v(" "), _c('progress-step4', {
    attrs: {
      "site-id": _vm.actionData.id,
      "row-data": _vm.actionData,
      "step-data": _vm.actionData.steps[3]
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" Land Owner")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h2', [_vm._v("Land Owner")]), _vm._v(" "), (!_vm.hasLandowner(_vm.site)) ? _c('div', [_c('center', [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("No landowner information found")])])], 1) : _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                    Owner\n                  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.name))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                    Address\n                  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.address))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                    Post Code\n                  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.postCode))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                    Phone\n                  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.phone))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                    e-Mail\n                  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.email))])])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a53e575"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/ProgressWorkflow.vue
// module id = 1544
// module chunks = 0